import React, { useEffect } from "react";
import { HeaderImgSection } from '../../Header/HeaderImgSection'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import slider from '../../../images/GRAPHIC DESIGNING/GRAPHIC-DESIGNING-1900-220.png'
import sidebar from '../../../images/GRAPHIC DESIGNING/GRAPHIC-DESIGNING-COMPANY.png'


function GraphicDesign  () {
  useEffect(() => {
    document.title = "Graphic Design || OZVASERVICE"
 }, []);
  return (
    <>
      <HeaderImgSection img={slider} hTitle={'Services'} title={"Graphic Design"}></HeaderImgSection>
      <Container className='my-5'>
        <h1 className='text-center text-primary fw-semibold '>Graphic Design</h1>
        <p className='text-center'>At OZVA SERVICE, we specialize in delivering innovative, visually compelling graphic design solutions that help businesses and individuals bring their ideas to life through captivating visuals. Our team of skilled designers is passionate about visual storytelling and creating designs that not only grab attention but also deliver a powerful message.</p>


        <Row className='my-5 align-items-center'>
          <Col lg={6} className='mb-lg-0 mb-3'>
            <h2 className='text-dark fw-semibold'>Your Trusted Graphic Design Partner</h2>
            <p>We understand the pivotal role design plays in effective communication. That’s why we've assembled a team of the industry's most talented graphic designers. Whether you're looking for logo design, branding, packaging, or marketing materials, we collaborate with you to create custom designs that align with your business needs.</p>
            <p>Our designers are more than just experts; they are creative innovators. We embrace the latest design techniques and technologies, constantly pushing the boundaries of what’s possible. By utilizing cutting-edge software and tools, we ensure that our designs remain ahead of industry trends, delivering visually stunning and impactful results.</p>
          <h2 className='fw-bold my-4'>What We Offer:</h2>
          <ul>
            <li className='fw-semibold'>Custom Logo Design:</li>
            <p> - Create a memorable first impression with a unique logo that truly represents your brand identity.</p>
            <li className='fw-semibold'>Branding & Identity:</li>
            <p> - Build a strong, consistent brand image across all touchpoints, from business cards to websites.</p>
            <li className='fw-semibold'>Packaging Design:</li>
            <p> - Design packaging that is both visually appealing and functional, enhancing the consumer experience.</p>
            <li className='fw-semibold'>Marketing Materials:</li>
            <p> - Design brochures, flyers, banners, and other materials that effectively communicate your message and drive engagement.</p>  

          </ul>
          
          </Col>
          <Col lg={6} className='d-flex justify-content-center align-items-center'>
            <div className="">
              <img src={sidebar} className='img-fluid rounded-2' alt="" />
            </div>
          </Col>
        </Row>

        

        <h2 className='fw-bold mb-4'>Why Choose OZVA SERVICE for Graphic Design?</h2>
        <p>We recognize that the design process can be complex and time-consuming. That's why we take great pride in our client-focused approach, ensuring that every project is executed with meticulous attention to detail and completed on time. Our team is always available to answer questions, resolve any issues, and make the entire process as seamless and stress-free as possible.</p>
        <p>In addition to our design expertise, we pride ourselves on our exceptional customer service. Our goal is to provide you with designs that not only look fantastic but also help your business achieve its objectives. Whether you’re launching a new brand or rebranding, OZVA SERVICE is committed to creating visually impactful solutions that set your business apart from the competition.</p>

      </Container>
    </>
  )
}

export default GraphicDesign
